export const Noop = (): null => null;
